<style scoped>

</style>
<template>
  <div></div>
</template>
<script>
  import CONFIG from '../../config/config';
  import Consumer from './libs/consumer';
  const EVENT_NAME = 'update-red-dot';
  export default {
    data() {
      return {
        //
      }
    },
    computed: {
      red_dot_hash() {
        return this.$store.state.red_dot_hash;
      },
    },
    created() {
      this.init();
      this.initEvents();
    },
    beforeDestroy() {
      this.offEvents();
    },
    methods: {
      init() {
        this.channel = Consumer.subscriptions.create({channel: 'RedDotChannel'}, {
          received: (data) => {
            // console.log('Update red dot:', data);
            const new_hash = Object.assign({}, this.red_dot_hash, data);
            this.$store.commit('setRedDotHash', new_hash);
          },
          connected:() => {
            // 获取所有时，请指定 app_token
            this.channel.send({token: 'all', app_token: CONFIG.app_token});
          }
        });
      },
      initEvents() {
        window.eventHub.$on(EVENT_NAME, (red_dot_token) => {
          this.channel.send({token: red_dot_token});
        });
      },
      offEvents() {
        window.eventHub.$off(EVENT_NAME);
      }
    }
  }
</script>
